import { useState, useEffect, useRef } from 'react';
import { Input } from './ui/input';
import { Search, Loader2, X } from 'lucide-react';
import api from '../lib/api';

const GifPicker = ({ onSelect, onClose }) => {
  const [query, setQuery] = useState('');
  const [gifs, setGifs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [trending, setTrending] = useState([]);
  const debounceRef = useRef(null);

  useEffect(() => {
    // Load trending on mount
    searchGifs('trending');
  }, []);

  const searchGifs = async (q) => {
    setLoading(true);
    try {
      const res = await api.get('/giphy/search', { params: { q, limit: 20 } });
      const data = Array.isArray(res.data) ? res.data : [];
      if (q === 'trending') {
        setTrending(data);
        if (!query) setGifs(data);
      } else {
        setGifs(data);
      }
    } catch {
      setGifs([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setQuery(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      if (value.trim()) {
        searchGifs(value.trim());
      } else {
        setGifs(trending);
      }
    }, 300);
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-lg p-3 w-80 max-h-96 flex flex-col">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-semibold text-dark-slate">Choose a GIF</span>
        <button onClick={onClose} className="p-1 rounded-full hover:bg-slate-100">
          <X className="w-4 h-4 text-slate-gray" />
        </button>
      </div>
      <div className="relative mb-2">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-gray" />
        <Input
          placeholder="Search GIFs..."
          value={query}
          onChange={(e) => handleSearch(e.target.value)}
          className="pl-8 h-8 text-sm rounded-lg"
          autoFocus
        />
      </div>
      <div className="flex-1 overflow-y-auto">
        {loading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="w-5 h-5 animate-spin text-slate-gray" />
          </div>
        ) : gifs.length === 0 ? (
          <p className="text-center text-sm text-slate-gray py-6">No GIFs found</p>
        ) : (
          <div className="grid grid-cols-2 gap-1.5">
            {gifs.map(gif => (
              <button
                key={gif.id}
                onClick={() => onSelect(gif.url)}
                className="rounded-lg overflow-hidden hover:opacity-80 transition-opacity"
              >
                <img src={gif.preview} alt={gif.title} className="w-full h-24 object-cover" loading="lazy" />
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="mt-2 pt-1 border-t border-slate-100">
        <p className="text-[10px] text-slate-gray text-center">Powered by GIPHY</p>
      </div>
    </div>
  );
};

export default GifPicker;
